import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IdelinkModuleTheme, useIdelinkTheme } from '../../configs/IdeLinkTheme';
import { NavbarModuleItem } from '../../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';
import { Module } from '../Module';
import { RouteItem } from '../../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { PrivateRoute } from '../../routes/PrivateRoute';
import { PermissionsActions } from '../../services/permissions/PermissionsActions';
import { ShopCreatePageLoading } from './Pages/ShopCreatePage/ShopCreatePageLoading';
import { ShopDetailsPageLoading } from './Pages/ShopDetailsPage/ShopDetailsPageLoading';
import { ShopListPageLoading } from './Pages/ShopListPage/ShopListPageLoading';
import { ShopsPermissions } from './Services/ShopsPermissions';
import { useIsPermissionsInitialized } from '../../../libs/IdeLink.Web.Common/src/Hooks/useIsPermissionsInitialized';

export class ShopsModule {
    public static SHOP_LIST: string = '/shops';
    public static SHOP_CREATE: string = '/shops/create';
    public static SHOP_DETAILS: string = '/shops/:id';

    private static getShopListRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: ShopsModule.SHOP_LIST,
            component: ShopListPageLoading,
            hasAccess: () => ShopsPermissions.Admin.canList,
        },
    });
    private static getShopCreateRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: ShopsModule.SHOP_CREATE,
            component: ShopCreatePageLoading,
            hasAccess: () => ShopsPermissions.Admin.canCreate,
        },
    });
    private static getShopDetailsRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: ShopsModule.SHOP_DETAILS,
            component: ShopDetailsPageLoading,
            hasAccess: () => ShopsPermissions.Admin.canRead,
        },
    });

    public static shopDetailsRoute = (shopId: string): string => {
        return `${ShopsModule.SHOP_DETAILS}`.replace(':id', shopId);
    };

    public static getShopsRoutes = (): Array<RouteItem> => {
        return [
            ShopsModule.getShopListRoute(),
            ShopsModule.getShopCreateRoute(),
            ShopsModule.getShopDetailsRoute(),
        ];
    };

    public static preloadShops = () => {
        ShopListPageLoading.preload();
        ShopCreatePageLoading.preload();
        ShopDetailsPageLoading.preload();
    };

    public static getShopsModuleNavbar = (shopsTheme: IdelinkModuleTheme): NavbarModuleItem => {
        return {
            icon: shopsTheme.navbarIcon,
            label: <FormattedMessage id="navbar.centers" />,
            route: ShopsModule.SHOP_LIST,
            onMouseOver: () => ShopsModule.preloadShops(),
            disabled: !ShopsPermissions.Admin.canRead,
            hide: PermissionsActions.shouldHideAdminSection(),
        };
    };
}

export const IdkShopsModule = () => {
    const ideLinkTheme = useIdelinkTheme();
    //this module need the permissions to load
    if (!useIsPermissionsInitialized()) {
        return null;
    }
    return (
        <Module
            moduleKey="ShopsModule"
            routes={ShopsModule.getShopsRoutes()}
            navBarItems={[ShopsModule.getShopsModuleNavbar(ideLinkTheme.shops)]}
        />
    );
};
